import * as Fonts from './font';
import * as Spacings from './spacings';
import * as Texts from './texts';
import * as Layouts from './layouts';
import * as Buttons from './buttons';
import * as Shadows from './shadows';

export { Fonts, Spacings, Texts, Layouts, Buttons, Shadows };
